const skills = [
  {
    name: "html",
    logo: require("../assets/logos/html5.svg"),
  },
  {
    name: "css",
    logo: require("../assets/logos/css.svg"),
  },
  {
    name: "javascript",
    logo: require("../assets/logos/javascript.svg"),
  },
  {
    name: "vue",
    logo: require("../assets/logos/vuejs.svg"),
  },
  {
    name: "react",
    logo: require("../assets/logos/reactjs.svg"),
  },
  {
    name: "bootstrap",
    logo: require("../assets/logos/bootstrap.svg"),
  },
  {
    name: "tailwind",
    logo: require("../assets/logos/tailwindcss.svg"),
  },
  {
    name: "node",
    logo: require("../assets/logos/nodejs.svg"),
  },
  {
    name: "npm",
    logo: require("../assets/logos/npmjs.svg"),
  },
  {
    name: "firebase",
    logo: require("../assets/logos/firebase.svg"),
  },
  {
    name: "sass",
    logo: require("../assets/logos/sass.svg"),
  },
  {
    name: "wordpress",
    logo: require("../assets/logos/wordpress.svg"),
  },
  {
    name: "mongodb",
    logo: require("../assets/logos/mongodb.svg"),
  },
  {
    name: "yarn",
    logo: require("../assets/logos/yarnpkg.svg"),
  },
  // {
  //   name: "google play",
  //   logo: require("../assets/logos/google_play.svg"),
  // },
];

export default skills;
